module.exports = __webpack_public_path__ + "static/img/item2.620476e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/web/item2.png
// module id = BQAv
// module chunks = 1